import { adminHttpClient } from '../../commons/adminHttpClient'
import { AddDefaultExpenseTypeRequest } from './addDefaultExpenseType'

export type DefaultExpenseTypeForEdit = AddDefaultExpenseTypeRequest

export interface GetExpenseTypeForEditRequest {
  expenseTypeId: number
  productId: number
}

const getDefaultExpenseTypeForEdit = ({
  expenseTypeId,
  productId,
}: GetExpenseTypeForEditRequest): Promise<DefaultExpenseTypeForEdit> =>
  adminHttpClient.get('Expenses/DefaultExpenseTypes/ForEdit', { expenseTypeId, productId })

export default getDefaultExpenseTypeForEdit
